/**
 * A chave de acesso "lida" em voz alta: cada trecho com o que significa. É o momento marcante
 * do login — uma única sequência de revelação, que respeita movimento reduzido (theme.css).
 */
const TRECHOS = [
  { digitos: '29', significado: 'UF da Bahia' },
  { digitos: '2609', significado: 'Emitida em setembro de 2026' },
  { digitos: '11122233000183', significado: 'CNPJ de quem emitiu' },
  { digitos: '55', significado: 'Modelo NF-e' },
  { digitos: '001', significado: 'Série' },
  { digitos: '000001199', significado: 'Número da nota' },
  { digitos: '1', significado: 'Emissão normal' },
  { digitos: '00012345', significado: 'Código aleatório' },
  { digitos: '0', significado: 'Dígito verificador' },
] as const;

export function ChaveAnotada() {
  return (
    <ol
      className="flex flex-wrap gap-x-3 gap-y-5"
      aria-label="Exemplo de chave de acesso decomposta"
    >
      {TRECHOS.map((trecho, i) => (
        <li
          key={trecho.significado}
          className="grid animate-surgir gap-2"
          style={{ animationDelay: `${String(120 + i * 70)}ms` }}
        >
          <span className="font-mono text-xl tracking-wider text-painel-marca-texto tabular sm:text-2xl">
            {trecho.digitos}
          </span>
          <span className="border-t border-painel-marca-suave/50 pt-1.5 text-xs text-painel-marca-suave">
            {trecho.significado}
          </span>
        </li>
      ))}
    </ol>
  );
}
